export default [
  { id: 1, name: 'БЦ Астрахань' },
  { id: 2, name: 'БЦ Биробиджан' },
  { id: 3, name: 'БЦ Владикавказ' },
  { id: 4, name: 'БЦ Владимир' },
  { id: 5, name: 'БЦ Вологда' },
  { id: 6, name: 'БЦ Иркутск' },
  { id: 7, name: 'БЦ Казань' },
  { id: 8, name: 'БЦ Курган' },
  { id: 9, name: 'БЦ Курск' },
  { id: 10, name: 'БЦ Нижний Новгород' },
  { id: 11, name: 'БЦ Новокузнецк' },
  { id: 12, name: 'БЦ Обнинск' },
  { id: 13, name: 'БЦ Одинцово' },
  { id: 14, name: 'БЦ Оренбург' },
  { id: 15, name: 'БЦ Рязань' },
  { id: 16, name: 'БЦ Санкт-Петербург' },
  { id: 17, name: 'БЦ Сириус' },
  { id: 18, name: 'БЦ Ставрополь' },
  { id: 19, name: 'БЦ Тверь' },
  { id: 20, name: 'БЦ Тула' },
  { id: 21, name: 'БЦ Улан-Удэ' },
  { id: 22, name: 'БЦ Элиста' },
  { id: 23, name: 'БЦ Ярославль' },
];
